export default {
  SET_CLIENT_SUMMARY: function (state, payloads) {
    state.clientSummaries = payloads;
  },
}
